import React, { Component } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
// import classNames from 'classnames';                                  /*strg + p to search files !!!!*/
// import { NamedLink } from '..';
import css from './PressSection.css';
import ExternalLink from '../ExternalLink/ExternalLink';

/*
import value1 from '../../assets/icons/checklist3.svg';
import value2 from '../../assets/icons/support3.svg';
import value3 from '../../assets/icons/worldPin3.svg';

*/

import article1 from '../../assets/articles/article1.webp';
import article2 from '../../assets/articles/article2.webp';
import article3 from '../../assets/articles/article3.webp';
import article4 from '../../assets/articles/article4.webp';
import article5 from '../../assets/articles/article5.webp';
import article6 from '../../assets/articles/article6.webp';
import article7 from '../../assets/articles/article7.webp';
import article8 from '../../assets/articles/article8.webp';
import article9 from '../../assets/articles/article9.webp';
import article10 from '../../assets/articles/article10.webp';
import article11 from '../../assets/articles/article11.webp';
import article12 from '../../assets/articles/article12.webp';
import article13 from '../../assets/articles/article13.webp';
import article14 from '../../assets/articles/article14.webp';
import article15 from '../../assets/articles/article15.webp';
import article16 from '../../assets/articles/article16.webp';
import article17 from '../../assets/articles/article17.webp';


export class PressSection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visibleClass: css.none,
      visibleLessButton: false,
      visibleMoreButton: true,
    };
  }

  render() {
    const moreClick = () => {
      if (this.state.visibleClass== css.none){
        this.setState({ 
          visibleClass: css.seen, 
          visibleLessButton: true,
          visibleMoreButton: false,
        })
      } 
    }

    const lessClick = () => {
      if (this.state.visibleClass== css.seen){
        this.setState({ 
          visibleClass: css.none,
          visibleLessButton: false,
          visibleMoreButton: true, 
        })
      } 
    }


    return (
        <>
        <div className={css.readmorecontainer}>
            <div className={css.container}>
                  <div className={css.articles}>
                      <ExternalLink
                        className={css.articlesItems}
                        href="https://www.zdf.de/gesellschaft/plan-b/plan-b-da-geht-was-deutschland-108.html"
                        >
                        <img src={article1} width="100%" alt=""></img>
                      </ExternalLink>
                      <ExternalLink
                        className={css.articlesItems}
                        href="https://www.business-punk.com/2021/07/reisen-mit-sozialem-nachhaltigem-aspekt-socialbnb-macht-es-moeglich/"
                        >
                        <img src={article2} width="100%" alt=""></img>
                      </ExternalLink>
                      <ExternalLink
                        className={css.articlesItems}
                        href="https://www.galileo.tv/abenteuer/socialbnb-charity-urlaub-soziale-projekte-unterstuetzen/"
                        >
                        <img src={article3} width="100%" alt=""></img>
                      </ExternalLink>
                       {/* GEO SAISON no link */}
                      <img className={css.articlesItems} src={article4} width="100%"></img>
                      <ExternalLink
                        className={css.articlesItems}
                        href="https://www.faz.net/aktuell/gesellschaft/jugend-schreibt/wer-bei-socialbnb-bucht-unterstuetzt-soziale-projekte-18154255.html"
                        >
                        <img src={article5} width="100%" alt=""></img>
                      </ExternalLink>

                      <ExternalLink
                        className={css.articlesItems}
                        href="https://www.n-tv.de/mediathek/magazine/startup_news/Socialbnb-vereint-Tourismus-und-globales-Engagement-article23603817.html"
                        >
                        <img src={article6} width="100%" alt=""></img>
                      </ExternalLink>
                  </div>
                    <span className={this.state.visibleClass}>
                      <div className={css.articles}>
                          {/* 1Live no link */}
                          <img className={css.articlesItems} src={article7} width="100%" alt=""></img>
                          <ExternalLink
                            className={css.articlesItems}
                            href="https://enorm-magazin.de/wirtschaft/social-business/social-entrepreneurship/soziale-innovationen"
                            >
                            <img src={article8} width="100%" alt=""></img>
                          </ExternalLink>
                          <ExternalLink
                            className={css.articlesItems}
                            href="https://www.startupvalley.news/de/socialbnb/"
                            >
                            <img src={article9} width="100%" alt=""></img>
                          </ExternalLink>
                          <ExternalLink
                            className={css.articlesItems}
                            href="https://www.lufthansagroup.com/de/newsroom/meldungen/socialbnb-gewinnt-changemaker-challenge.html"
                            >
                            <img src={article10} width="100%"></img>
                          </ExternalLink>
                          {/* Brigitte no link */}
                          <img className={css.articlesItems} src={article11} width="100%" alt=""></img>
                          {/* DBMobil no link */}
                          <img className={css.articlesItems} src={article12} width="100%" alt=""></img>
                      </div>
                      <div className={css.articles}>
                        <ExternalLink
                          className={css.articlesItems}
                          href="https://www.br.de/puls/themen/welt/socialbnb-sozialvertraeglich-reisen-100.html"
                          >
                          <img src={article13} width="100%" alt=""></img>
                        </ExternalLink>
                        <ExternalLink
                          className={css.articlesItems}
                          href="https://utopia.de/ratgeber/socialbnb-uebernachten-und-gutes-tun/"
                          >
                          <img src={article14} width="100%" alt=""></img>
                        </ExternalLink>
                        <ExternalLink
                          className={css.articlesItems}
                          href="https://www.deutschlandfunkkultur.de/gruenderstipendium-in-nrw-gefoerdert-wird-was-innovativ-ist.1001.de.html?dram:article_id=504253"
                          >
                          <img src={article15} width="100%" alt=""></img>
                        </ExternalLink>
                        <ExternalLink
                          className={css.articlesItems}
                          href="https://reisevergnuegen.com/socialbnb-nachhaltig-reisen/"
                          >
                          <img src={article16} width="100%" alt=""></img>
                        </ExternalLink>
                        <ExternalLink
                          className={css.articlesItems}
                          href="https://www.unwto.org/unwto-awake-tourism-challenge"
                          >
                          <img src={article17} width="100%" alt=""></img>
                        </ExternalLink>
                      </div>
                    </span>
                
            </div>
            <span className={this.state.visibleMoreButton ? css.readmorebtn : css.none} onClick={moreClick} ><FormattedMessage id="LandingPage.pressSectionButtonMore" /></span>
            <span className={this.state.visibleLessButton ? css.readmorebtn : css.none} onClick={lessClick} ><FormattedMessage id="LandingPage.pressSectionButtonWeniger" /></span>
        </div>

        
        </>
    );
      
     
  }
}



export default PressSection;